import {get} from 'utils/axios/index'
import {toast} from 'react-toastify'
import {DefaultApiResponse} from 'models/ApiResponse'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'

const fetchState = async () => {
 try {
  return await get<DefaultApiResponse>(
   '/location/v1/states'
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const fetchDistrict = async (state: number | null) => {
 try {
  return await get<DefaultApiResponse>(
   '/location/v1/districts',
   {
    state,
   }
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const fetchSubDistrict = async (
 district_id: number | null
) => {
 try {
  return await get<DefaultApiResponse>(
   '/location/v1/sub-districts',
   {
    district_id,
   }
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const fetchTerritories = async (
 district_id: number | null
) => {
 try {
  return await get<DefaultApiResponse>(
   '/location/v1/territories',
   {
    district_id,
   }
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

export {
 fetchDistrict,
 fetchState,
 fetchSubDistrict,
 fetchTerritories,
}
